import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Operator from './Operator'

const MoreLessEquals = props => {
	const { operators, label, value, defaultValue = {}, onChange } = props

	const [operatorState, setOperator] = useState(defaultValue.symbol)
	const [fieldvalueState, setValue] = useState(defaultValue.value)

	const operator = value ? value.symbol : operatorState
	const fieldvalue = (value ? value.value : fieldvalueState) || ''

	const handleChangeOperator = changedOperator => {
		const newOperator = changedOperator === operator ? null : changedOperator
		const newValue = newOperator ? {
			value: fieldvalue || null,
			symbol: newOperator
		} : null
		setOperator(newOperator)
		if(onChange) {
			onChange(newValue)
		}
	}

	const handleChangeValue = changedValue => {
		const newFieldvalue = changedValue ? Number(changedValue) : null
		const newValue = {
			value: newFieldvalue,
			symbol: operator
		}
		setValue(newFieldvalue)
		if(onChange) {
			onChange(newValue)
		}
	}

	return(
		<div>
			<p>{label}</p>
			<StyledOperatorContainer expanded={operator}>
				{operators.map(({ display, name }, i) => (
					<Operator
						key={i}
						onChange={e => handleChangeValue(e.target.value)}
						active={name === operator}
						value={fieldvalue}
						text={display}
						onClick={e => handleChangeOperator(name)} />
				))}
			</StyledOperatorContainer>
		</div>
	)
}

const StyledOperatorContainer = styled.div`
	display: flex;
	justify-content: space-between;
	transition: max-width 0.3s;
	max-width: ${({ expanded }) => expanded ? '150px' : '80px'};
`

MoreLessEquals.propTypes = {
	operators: PropTypes.arrayOf(PropTypes.shape({
		display: PropTypes.string,
		name: PropTypes.string
	})).isRequired,
	value: PropTypes.shape({
		symbol: PropTypes.string,
		value: PropTypes.any
	}),
	defaultValue: PropTypes.arrayOf(PropTypes.string),
	label: PropTypes.string
}

MoreLessEquals.defaultProps = {
	operators: [{
		display: '=',
		name: 'equal'
	}, {
		display: '>',
		name: 'moreThan'
	}, {
		display: '<',
		name: 'lessThan'
	}],
	defaultValue: []
}

export default MoreLessEquals
